import { addListener } from "packages/pf-icon/src/iconFirst.js";

addListener();
